import { render, staticRenderFns } from "./ylc_list.vue?vue&type=template&id=593ff176&scoped=true&"
import script from "./ylc_list.vue?vue&type=script&lang=js&"
export * from "./ylc_list.vue?vue&type=script&lang=js&"
import style0 from "./ylc_list.vue?vue&type=style&index=0&id=593ff176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593ff176",
  null
  
)

export default component.exports